import type { VolumeDiscountsModeAssignmentsResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useVolumeDiscountsModeAssignments = (
  options?: ApiV2QueryOptions<VolumeDiscountsModeAssignmentsResponseType>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [business?.id, ServerStateKeys.VolumeDiscountsModeAssignments],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "volume-discounts/mode/assignments",
      }).then(
        (response) =>
          apiV2AssertResponse<VolumeDiscountsModeAssignmentsResponseType>(
            response,
          ).data,
      ),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: options,
    }),
  });
};
